import { Mui } from "@osu/react-ui";
import { mergeSxStyles } from "../../../../../util/functions";

export function DescriptionItem({
  label,
  value,
  isTitle = false,
  sx,
  ...rest
}) {
  return (
    <Mui.Typography
      component={isTitle ? "dt" : "dd"}
      sx={mergeSxStyles(
        {
          display: "flex",
          flexDirection: "column",
          pb: 1,
        },
        sx
      )}
      variant="subtitle2"
      {...rest}
    >
      {label}
      <Mui.Typography variant="body2" component="span">{value}</Mui.Typography>
    </Mui.Typography>
  );
}
